import React, { useState, useEffect, useCallback, useMemo } from 'react'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Step from '@material-ui/core/Step';
import Stepper from '@material-ui/core/Stepper';
import StepConnector from '@material-ui/core/StepConnector';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Description from '@material-ui/icons/Description';
import Spellcheck from '@material-ui/icons/Spellcheck';
import Send from '@material-ui/icons/Send';
import Check from '@material-ui/icons/Check';
import HighlightOff from '@material-ui/icons/HighlightOff';
import SendOutlined from '@material-ui/icons/SendOutlined';

import { convertNumber } from 'utils/convertExcelNumber'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import moment from 'moment'

import SendingStandardReportModalSuccess from '../../../components/users/standard-report/success-modal'
import SendingStandardReportModalFailed from '../../../components/users/standard-report/failed-modal'
import SureModal from '../../../components/SureModal'
import StepContent from '../../../components/users/standard-report/index'
import EmptyFileModal from '../../../components/users/standard-report/empty-file-modal'

import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'


import { makeStyles, withStyles } from '@material-ui/core/styles'
import { useStoreState, useStoreActions } from '../../../store'
import { form, datasetRecord, users as userAPI } from '../../../api/index'
import { useHistory } from 'react-router-dom'
import { getReportData } from '../../../data/report-config'
import zeroMapping from '../../../data/zero-to-noservice-mapping.json'

// import { fixed_general_details } from '../../../data/standard-reportV2_2/fixed-general'
// import { fixed_info_details } from '../../../data/standard-reportV2_2/fixed-info'
// import { fixed_sound_details } from '../../../data/standard-reportV2_2/fixed-sound'
// import { mobile_general_details } from '../../../data/standard-reportV2_2/mobile-general'
// import { mobile_info_details } from '../../../data/standard-reportV2_2/mobile-info'
// import { mobile_sound_details } from '../../../data/standard-reportV2_2/mobile-sound'
// import { mobile_additional_files } from '../../../data/standard-reportV2/ui/mobile-additional-files'

const nonFloatDataSetItemIDs = [
	337,
	338,
	339,
	340,
	341,
	342,
	343,
];
const useStyles = makeStyles(theme => ({
	root: {
		width: '100%',
	},
	button: {
		marginRight: theme.spacing(1),
	},
	instructions: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
	},
	non_approve_button: {
		backgroundColor: '#c33939',
		color: 'white',
		'&:hover': {
			backgroundColor: '#a33e3e',
		},
	},
}))

const Connector = withStyles({
	alternativeLabel: {
		top: 22,
	},
	active: {
		'& $line': {
			backgroundColor: '#a74345',
		},
	},
	completed: {
		'& $line': {
			backgroundColor: '#a74345',
		},
	},
	line: {
		height: 3,
		border: 0,
		backgroundColor: '#eaeaf0',
		borderRadius: 1,
	},
})(StepConnector)

const useStepStyles = makeStyles({
	root: {
		backgroundColor: '#ccc',
		zIndex: 1,
		color: '#fff',
		width: 50,
		height: 50,
		display: 'flex',
		borderRadius: '50%',
		justifyContent: 'center',
		alignItems: 'center',
	},
	active: {
		backgroundColor: '#a74345',
		boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
	},
	completed: {
		backgroundColor: '#a74345',
	},
})

function getSteps() {
	return [
		'รูปแบบการส่งรายงาน',
		'บันทึกข้อมูล',
		'หัวข้อที่ไม่ผ่านเกณฑ์และส่งรายงาน',
	]
}

function getStepsWithMobile() {
	return [
		'รูปแบบการส่งรายงาน',
		'บันทึกข้อมูล',
		'แนบไฟล์เพิ่มเติมสำหรับรายงานมาตรฐานแบบเคลื่อนที่',
		'หัวข้อที่ไม่ผ่านเกณฑ์และส่งรายงาน',
	]
}

function StepperIcon(props) {
	const classes = useStepStyles()
	const { active, completed, hasMobile } = props

	const icons = {
		1: <Description />,
		2: <Spellcheck />,
		3: hasMobile ? <Send /> : <HighlightOff />,
		4: <HighlightOff />,
	}

	return (
		<div
			className={clsx(classes.root, {
				[classes.active]: active,
				[classes.completed]: completed,
			})}>
			{completed ? <Check /> : icons[String(props.icon)]}
		</div>
	)
}

StepperIcon.propTypes = {
	active: PropTypes.bool,
	completed: PropTypes.bool,
	icon: PropTypes.node,
	hasMobile: PropTypes.bool,
}

const StandardReport = () => {
	// **
	const [fixed_general_details, setFixedGeneralDetails] = useState(null);
	const [fixed_info_details, setFixedInfoDetails] = useState(null);
	const [fixed_sound_details, setFixedSoundDetails] = useState(null);
	const [mobile_general_details, setMobileGeneralDetails] = useState(null);
	const [mobile_info_details, setMobileInfoDetails] = useState(null);
	const [mobile_sound_details, setMobileSoundDetails] = useState(null);
	const [mobile_additional_files, setMobileAdditionalFiles] = useState(null);
	//
	const classes = useStyles()
	const history = useHistory()
	const user = useStoreState(s => s.userModel.user)
	const steps = getSteps()
	const stepsMobile = getStepsWithMobile()
	const [activeStep, setActiveStep] = useState(0)
	const userOperatorProfile = useStoreState(
		s => s.userModel.userOperatorProfile
	)
	const [hasMounted, setHasMounted] = useState(false)
	const [loading, setLoading] = useState(false)

	// Types of Required Filled Standard Report Form
	const [hasMobile, setHasMobile] = useState(false)
	const [needToFillFormType, setNeedToFillFormType] = useState([
		'fixed-general',
		'fixed-sound',
		'fixed-info',
		'mobile-general',
		'mobile-sound',
		'mobile-info',
	])
	// Amount of Required Filled Standard Report Form
	const [filledFormAmount, setFilledFormAmount] = useState(0)
	// Current Page of Required Filled Standard Report Form
	const [currentFilledFormIndex, setCurrentFilledFormIndex] = useState(0)
	// Report Method State
	const [reportMethod, setReportMethod] = useState('web-form')
	const [reportVersion, setReportVersion] = useState(2) // set for lastest version * default version of QoS Form
	const [fixedReportType, setFixedReportType] = useState(false)
	const [mobileReportType, setMobileReportType] = useState(false)
	// Standard Report Form Answers
	const [fixedGeneralAnswers, setFixedGeneralAnswers] = useState([])
	const [fixedInfoAnswers, setFixedInfoAnswers] = useState([])
	const [fixedSoundAnswers, setFixedSoundAnswers] = useState([])
	const [mobileGeneralAnswers, setMobileGeneralAnswers] = useState([])
	const [mobileInfoAnswers, setMobileInfoAnswers] = useState([])
	const [mobileSoundAnswers, setMobileSoundAnswers] = useState([])
	// Standard Report Submiting Modal Status
	const [openStandardReportSuccessModal, setOpenStandardReportSuccessModal] =
		useState(false)
	const [openStandardReportFailedModal, setOpenStandardReportFailedModal] =
		useState(false)
	const [sendingFailedMessage, setSendingFailedMessage] = useState('')
	// Sure Modal
	const [
		openSubmitStandardReportSureModal,
		setOpenSubmitStandardReportSureModal,
	] = useState(false)
	// Standard Report Excel File
	const [excelFile, setExcelFile] = useState(null)
	const [excelFileShow, setExcelFileShow] = useState('')
	// Mobile Report Additional Files
	const [mobileFiles, setMobileFiles] = useState({})

	// Upload Excel Status
	const [uploadExcelStatus, setUploadExcelStatus] = useState(null)
	// Preview Answers to persist across steps
	const [previewAnswers, setPreviewAnswers] = useState([])

	// Has Ever Submit Form Status
	const [hasEverSubmitedForm, setHasEverSubmitedForm] = useState(false)
	// Continue Form Submitted ID
	const [continueFormSubmittedID, setContinueFormSubmittedID] = useState(null)
	// Continue Form Submmited Type
	const [continueFormSubmittedType, setContinueFormSubmittedType] = useState({
		isFixed: false,
		isMobile: false,
		formVersion: reportVersion,

	})
	// All Data from CurrentHead
	const [currentHeadData, setCurrentHeadData] = useState(null)
	// Is continue From Submitted Form
	const [isNewForm, setIsNewForm] = useState('y')
	// Form Flags
	const [flags, setFlags] = useState({
		'2G': false,
		NVMO: false,
		payphone: false,
	})
	// Invalid Data Set Records
	const [invalidDataSetRecords, setInvalidDataSetRecords] = useState([])
	const [invalidAnswers, setInvalidAnswers] = useState([])
	// Invalid Input Method
	const [invalidInputMethod, setInvalidInputMethod] = useState('message')
	// Open Asking Validation Modal
	const [openAskingValidationModal, setOpenAskingValidationModal] =
		useState(false)
	// Current Validation Question Number
	const [currentValiationQuestionNumber, setCurrentValidationQuestionNumber] =
		useState('')
	// Current Selected Validation
	const [currentSelectedItem, setCurrentSelectedItem] = useState({
		id: '',
		question_number: '',
		label: '',
		errors: '',
		inputMethod: '',
		periodSolution: null,
	})
	// Filling Modal
	const [openFillingModal, setOpenFillingModal] = useState(false)
	// Quarter State
	const [quarter, setQuarter] = useState(null)

	const { userOperatorProfile: userProfile } = useStoreState(s => s.userModel)

	const isUseReport1_1_2 = useMemo(
		() => userProfile?.isUseReport1_1_2,
		[userProfile]
	)

	const { getUserOperatorProfile } = useStoreActions(s => s.userModel)

	useEffect(() => {
		getUserOperatorProfile()
		// eslint-disable-next-line
	}, [])

	/** ---------------------------------------------- */

	/**  Main Stepper Handle Function */

	//** */
	//** */
	const loadReportData = async () => {
		try {
			const reportData = getReportData(reportVersion)

			setFixedGeneralDetails(reportData.fixed_general_details || []);
			setFixedInfoDetails(reportData.fixed_info_details || []);
			setFixedSoundDetails(reportData.fixed_sound_details || []);
			setMobileGeneralDetails(reportData.mobile_general_details || []);
			setMobileInfoDetails(reportData.mobile_info_details || []);
			setMobileSoundDetails(reportData.mobile_sound_details || []);
			setMobileAdditionalFiles(reportData.mobile_additional_files || []);
		} catch (error) {
			console.error('Error loading report data:', error);
		}
	};
	//

	const handleNext = async () => {
		if (
			activeStep === (hasMobile ? stepsMobile.length - 1 : steps.length - 1)
		) {
			if (invalidDataSetRecords.length !== 0) {
				const isPass = invalidAnswers.every(
					item =>
						(item.reason !== '' &&
							item.solution !== '' &&
							item.periodSolution !== null) ||
						item.file !== null
				)

				if (isPass) onOpenSubmitStandardReportSureModal()
				else alert('กรุณากรอกเหตุผลให้ครบถ้วน')
			} else if (invalidDataSetRecords.length === 0)
				onOpenSubmitStandardReportSureModal()
		} else if (activeStep === 2 && hasMobile) {
			setActiveStep(prevActiveStep => prevActiveStep + 1)
		} else if (activeStep === 1 && reportMethod === 'upload') {
			uploadExcel()
		}
		// Saves the form and Validate the form then Shows a modal status
		else if (
			activeStep === 1 &&
			currentFilledFormIndex === filledFormAmount - 1
		) {
			SubmitForm()
		}
		// Shows the next required filled standard report form
		else if (activeStep === 1 && currentFilledFormIndex < filledFormAmount - 1)
			onIncrementCurrentFilledFormIndex()
		else if (activeStep === 0 && isNewForm === 'n') {
			await onLoadDataSetRecordToContinue()
			setActiveStep(prevActiveStep => prevActiveStep + 1)
		} else if (activeStep !== steps.length - 1)
			setActiveStep(prevActiveStep => prevActiveStep + 1)
	}

	const handleBack = () => {
		// Shows the previous required filled standard report form
		if (activeStep === 1 && currentFilledFormIndex === 0) setActiveStep(0)
		else if (activeStep === 1 && currentFilledFormIndex <= filledFormAmount - 1)
			onDecrementCurrentFilledFormIndex()
		/**
		 * General cases:
		 * - Step 2 -> Step 1 (To first required standard report form)
		 * - Step 3 -> Step 2 (To last required filled standard report form)
		 */ else setActiveStep(prevActiveStep => prevActiveStep - 1)
	}



	/** ---------------------------------------------- */

	// Open Standard Report Success Modal Handler
	const onOpenStandardReportSuccessModal = () =>
		setOpenStandardReportSuccessModal(!openStandardReportSuccessModal)

	const onAgreeStandardReportSuccessModalCTA = () => {
		onOpenStandardReportSuccessModal()
		history.go(0)
	}

	// Open Standard Report Failed Modal Handler
	const onOpenStandardReportFailedModal = () => {
		setOpenStandardReportFailedModal(!openStandardReportFailedModal)
	}

	/** ---------------------------------------------- */

	// Modal Empty File
	const [openEmptyFileModal, setOpenEmptyFileModal] = useState(false)

	const onOpenEmptyFileModal = () => setOpenEmptyFileModal(!openEmptyFileModal)
	// <-------------------------------------

	/** Step 1 */

	const onChangeReportType = (type, checked) => {
		if (type === 1) setFixedReportType(checked)
		else if (type === 2) setMobileReportType(checked)
	}

	const setVersion = (version) => {
		setReportVersion(version)
	}

	const onChangeRadio = async e => {
		const method = e.target.value
		setReportMethod(method)
		if (method === 'upload') {
			let temp = {
				fixed: true,
				mobile: true,
			}
			const currentOperatorId = user?.operatorAccess?.[0]?.operatorID
				|| user?.operatorAccess?.[0]?.operatorId
				|| user?.operator?.id
				|| user?.operatorID
				|| user?.operatorId
				|| ''

			const res = await userAPI.getMyQosTypes(currentOperatorId)
			if (res && res.data) {
				temp = {
					fixed: res.data.fixed,
					mobile: res.data.mobile,
				}
			} else {
				temp = {
					fixed: false,
					mobile: false,
				}
			}
			setFixedReportType(temp.fixed)
			setMobileReportType(temp.mobile)
		}
	}

	const onChangeIsContinueRadio = e => {
		if (e.target.value === 'n') {
			setFixedReportType(continueFormSubmittedType.isFixed)
			setMobileReportType(continueFormSubmittedType.isMobile)
			setReportVersion(continueFormSubmittedType.version)
		}

		setIsNewForm(e.target.value)
	}

	const onLoadDataSetRecordToContinue = async () => {
		const res = await datasetRecord.getlistdetails(continueFormSubmittedID)
		if (res) {
			setQuarter(res.info.quarter || res.info.Quarter)
			const tempFixedGeneralAnswers = []
			const tempFixedSoundAnswers = []
			const tempFixedInfoAnswers = []
			const tempMobileGeneralAnswers = []
			const tempMobileSoundAnswers = []
			const tempMobileInfoAnswers = []

			res.data.forEach(item => {
				var newitem = {};
				if (nonFloatDataSetItemIDs.includes(item.dataSetItemID)) {
					newitem = {
						DataSetItemID: item.dataSetItemID,
						DataValueMonth1: item.dataValueMonth1
							? item.dataValueMonth1
							: '',
						DataValueMonth2: item.dataValueMonth2
							? item.dataValueMonth1
							: '',
						DataValueMonth3: item.dataValueMonth3
							? item.dataValueMonth3
							: '',
						DataValueMonthAvg: item.dataValueMonthAvg
							? item.dataValueMonthAvg
							: '',
						DataValueExtra: item.dataValueExtra
							? item.dataValueExtra
							: '',
					}
				} else {
					newitem = {
						DataSetItemID: item.dataSetItemID,
						DataValueMonth1: item.dataValueMonth1
							? convertNumber(item.dataValueMonth1, true)
							: '',
						DataValueMonth2: item.dataValueMonth2
							? convertNumber(item.dataValueMonth2, true)
							: '',
						DataValueMonth3: item.dataValueMonth3
							? convertNumber(item.dataValueMonth3, true)
							: '',
						DataValueMonthAvg: item.dataValueMonthAvg
							? convertNumber(item.dataValueMonthAvg, true)
							: '',
						DataValueExtra: item.dataValueExtra
							? item.dataValueExtra
							: '',
					}
				}
				if (reportVersion === 1) {
					if (item.dataSetItemID <= 10) tempFixedGeneralAnswers.push(newitem)
					else if (item.dataSetItemID <= 20) tempFixedSoundAnswers.push(newitem)
					else if (item.dataSetItemID <= 30) tempFixedInfoAnswers.push(newitem)
					else if (item.dataSetItemID <= 40)
						tempMobileGeneralAnswers.push(newitem)
					else if (item.dataSetItemID <= 200) tempMobileSoundAnswers.push(newitem)
					else if (item.dataSetItemID > 200) tempMobileInfoAnswers.push(newitem)
				} else {
					// tempFixedGeneralAnswers 11xxx
					// tempFixedSoundAnswers 12xxx
					// tempFixedInfoAnswers 13xxx
					// tempMobileGeneralAnswers 21xxx
					// tempMobileSoundAnswers 22xxx
					// tempMobileInfoAnswers 23xxx

					if (item.dataSetItemID <= 11999) tempFixedGeneralAnswers.push(newitem)
					else if (item.dataSetItemID <= 12999) tempFixedSoundAnswers.push(newitem)
					else if (item.dataSetItemID <= 13999) tempFixedInfoAnswers.push(newitem)
					else if (item.dataSetItemID <= 21999)
						tempMobileGeneralAnswers.push(newitem)
					else if (item.dataSetItemID <= 22999) tempMobileSoundAnswers.push(newitem)
					else if (item.dataSetItemID > 22999) tempMobileInfoAnswers.push(newitem)
				}
			})

			if (tempFixedGeneralAnswers.length !== 0)
				setFixedGeneralAnswers(tempFixedGeneralAnswers)
			if (tempFixedInfoAnswers.length !== 0)
				setFixedInfoAnswers(tempFixedInfoAnswers)
			if (tempFixedSoundAnswers.length !== 0)
				setFixedSoundAnswers(tempFixedSoundAnswers)
			if (tempMobileGeneralAnswers.length !== 0)
				setMobileGeneralAnswers(tempMobileGeneralAnswers)
			if (tempMobileInfoAnswers.length !== 0)
				setMobileInfoAnswers(tempMobileInfoAnswers)
			if (tempMobileSoundAnswers.length !== 0)
				setMobileSoundAnswers(tempMobileSoundAnswers)
		}
	}

	/** ---------------------------------------------- */

	/** Step 2 */

	const onFillForm = (form_type, id, answer_type, value) => {
		// Check Input have only number and .
		var pattern = /^[0-9.\b]+$/
		// if id is in nonFloatDataSetItemIDs, then set pattern to free input
		if (nonFloatDataSetItemIDs.includes(id)) {
			pattern = /^.*$/
		}
		if (answer_type === 'dataValueExtra' || answer_type === 'DataValueExtra') {
			pattern = /^.*$/
		}

		// limit length to 10
		if (answer_type === 'dataValueExtra' || answer_type === 'DataValueExtra') {
			if (value.length > 250) {
				return
			}
		} else if (value.length > 15) {
			return
		}

		// Sets new answers into answers state.
		if (pattern.test(value) || value === '') {
			if (form_type === 'fixed-general') {
				setFixedGeneralAnswers(prevState => {
					const newList = prevState.map((item, key) => {
						if (item.DataSetItemID === id) {
							return { ...prevState[key], [answer_type]: value }
						}
						return item
					})
					return newList
				})
			} else if (form_type === 'fixed-info') {
				setFixedInfoAnswers(prevState => {
					const newList = prevState.map((item, key) => {
						if (item.DataSetItemID === id) {
							return { ...prevState[key], [answer_type]: value }
						}
						return item
					})
					return newList
				})
			} else if (form_type === 'fixed-sound') {
				setFixedSoundAnswers(prevState => {
					const newList = prevState.map((item, key) => {
						if (item.DataSetItemID === id) {
							return { ...prevState[key], [answer_type]: value }
						}
						return item
					})
					return newList
				})
			} else if (form_type === 'mobile-general') {
				setMobileGeneralAnswers(prevState => {
					const newList = prevState.map((item, key) => {
						if (item.DataSetItemID === id) {
							return { ...prevState[key], [answer_type]: value }
						}
						return item
					})
					return newList
				})
			} else if (form_type === 'mobile-info') {
				setMobileInfoAnswers(prevState => {
					const newList = prevState.map((item, key) => {
						if (item.DataSetItemID === id) {
							return { ...prevState[key], [answer_type]: value }
						}
						return item
					})
					return newList
				})
			} else if (form_type === 'mobile-sound') {
				setMobileSoundAnswers(prevState => {
					const newList = prevState.map((item, key) => {
						if (item.DataSetItemID === id) {
							return { ...prevState[key], [answer_type]: value }
						}
						return item
					})
					return newList
				})
			}
		}
	}

	const onChangeNeedToFillFormType = () => {
		if (!hasMounted) return

		const temp = []

		if (fixedReportType) {
			temp.push('fixed-general')
			if (isUseReport1_1_2) {
				temp.push('fixed-sound')
			}
			temp.push('fixed-info')
		}

		if (mobileReportType) {
			temp.push('mobile-general')
			temp.push('mobile-sound')
			temp.push('mobile-info')
			setHasMobile(true)
		} else setHasMobile(false)

		setNeedToFillFormType(temp)
	}

	const onIncrementCurrentFilledFormIndex = () =>
		setCurrentFilledFormIndex(currentFilledFormIndex + 1)

	const onDecrementCurrentFilledFormIndex = () =>
		setCurrentFilledFormIndex(currentFilledFormIndex - 1)

	const SubmitForm = async () => {
		let records = []
		setLoading(true)
		needToFillFormType.forEach(form_type => {
			if (form_type === 'fixed-general')
				records = [...records, ...fixedGeneralAnswers]
			if (form_type === 'fixed-info')
				records = [...records, ...fixedInfoAnswers]
			if (form_type === 'fixed-sound') {
				if (isUseReport1_1_2) {
					records = [...records, ...fixedSoundAnswers]
				}
			}
			if (form_type === 'mobile-general')
				records = [...records, ...mobileGeneralAnswers]
			if (form_type === 'mobile-sound')
				records = [...records, ...mobileSoundAnswers]
			if (form_type === 'mobile-info')
				records = [...records, ...mobileInfoAnswers]
		})

		const formTypes = []

		if (isNewForm === 'y') {
			if (mobileReportType) formTypes.push(1)
			if (fixedReportType) formTypes.push(2)
		} else {
			if (continueFormSubmittedType.isFixed) formTypes.push(2)
			if (continueFormSubmittedType.isMobile) formTypes.push(1)
		}
		// version mush be int
		const version = parseInt(reportVersion)

		const res = await form.addRecord(records, isNewForm, formTypes, version)

		if (res?.data?.status === 'Incorrect') {
			const tempInvalidDataSetRecords = res.data.validateResult.map(item => {
				let question = null
				let formType = ''

				if (fixed_general_details.find(q => q.id === item.dataSetItemID)) {
					question = fixed_general_details.find(q => q.id === item.dataSetItemID)
					formType = 'fixed-general'
				} else if (fixed_info_details.find(q => q.id === item.dataSetItemID)) {
					question = fixed_info_details.find(q => q.id === item.dataSetItemID)
					formType = 'fixed-info'
				} else if (fixed_sound_details.find(q => q.id === item.dataSetItemID)) {
					question = fixed_sound_details.find(q => q.id === item.dataSetItemID)
					formType = 'fixed-sound'
				} else if (mobile_general_details.find(q => q.id === item.dataSetItemID)) {
					question = mobile_general_details.find(q => q.id === item.dataSetItemID)
					formType = 'mobile-general'
				} else if (mobile_info_details.find(q => q.id === item.dataSetItemID)) {
					question = mobile_info_details.find(q => q.id === item.dataSetItemID)
					formType = 'mobile-info'
				} else if (mobile_sound_details.find(q => q.id === item.dataSetItemID)) {
					question = mobile_sound_details.find(q => q.id === item.dataSetItemID)
					formType = 'mobile-sound'
				}

				let label = question?.label || ''

				if (question?.subLabel_2) {
					label = `${label} ${question.subLabel_1} (${question.subLabel_2})`
				} else if (question?.subLabel_1) {
					label = `${label} ${question.subLabel_1}`
				}

				return {
					id: question?.id,
					question_number: question?.no,
					label: label,
					errors: item.errors.toString(),
					inputMethod: 'message',
					question: question,
					formType: formType,
				}
			})

			const tempInvalidAnswers = res.data.validateResult.map(item => {
				const formVersionStr = reportVersion.toString()
				let isAllZero = false

				if (zeroMapping[formVersionStr] && zeroMapping[formVersionStr].includes(item.dataSetItemID)) {
					const record = records.find(r => r.DataSetItemID === item.dataSetItemID)
					if (record) {
						let m1 = 1, m2 = 1, m3 = 1, avg = 1;
						if (record.DataValueMonth1 !== '') m1 = parseFloat(record.DataValueMonth1) || 0;
						if (record.DataValueMonth2 !== '') m2 = parseFloat(record.DataValueMonth2) || 0;
						if (record.DataValueMonth3 !== '') m3 = parseFloat(record.DataValueMonth3) || 0;
						if (record.DataValueMonthAvg !== '') avg = parseFloat(record.DataValueMonthAvg) || 0;

						const isM1Zero = record.DataValueMonth1 !== '' && Math.abs(m1) < 0.0000001;
						const isM2Zero = record.DataValueMonth2 !== '' && Math.abs(m2) < 0.0000001;
						const isM3Zero = record.DataValueMonth3 !== '' && Math.abs(m3) < 0.0000001;
						const isAvgZero = record.DataValueMonthAvg !== '' && Math.abs(avg) < 0.0000001;

						const hasData = record.DataValueMonth1 !== '' || record.DataValueMonth2 !== '' || record.DataValueMonth3 !== '' || record.DataValueMonthAvg !== '';
						let allProvidedAreZero = true;

						if (record.DataValueMonth1 !== '' && !isM1Zero) allProvidedAreZero = false;
						if (record.DataValueMonth2 !== '' && !isM2Zero) allProvidedAreZero = false;
						if (record.DataValueMonth3 !== '' && !isM3Zero) allProvidedAreZero = false;
						if (record.DataValueMonthAvg !== '' && !isAvgZero) allProvidedAreZero = false;

						if (hasData && allProvidedAreZero) {
							isAllZero = true;
						}
					}
				}

				return {
					id: item.dataSetItemID,
					reason: isAllZero ? 'ไม่มีบริการ' : '',
					solution: isAllZero ? '-' : '',
					periodSolution: isAllZero ? new Date() : null,
					file: null,
					dbID: item.id,
					inputMethod: isAllZero ? 'no_service' : 'message',
				}
			})

			setInvalidDataSetRecords([...tempInvalidDataSetRecords])
			setInvalidAnswers([...tempInvalidAnswers])
		}
		setLoading(false)
		setActiveStep(prev => prev + 1)
	}

	const handleReValidate = async () => {
		let records = []
		setLoading(true)
		needToFillFormType.forEach(form_type => {
			if (form_type === 'fixed-general')
				records = [...records, ...fixedGeneralAnswers]
			if (form_type === 'fixed-info')
				records = [...records, ...fixedInfoAnswers]
			if (form_type === 'fixed-sound') {
				if (isUseReport1_1_2) {
					records = [...records, ...fixedSoundAnswers]
				}
			}
			if (form_type === 'mobile-general')
				records = [...records, ...mobileGeneralAnswers]
			if (form_type === 'mobile-sound')
				records = [...records, ...mobileSoundAnswers]
			if (form_type === 'mobile-info')
				records = [...records, ...mobileInfoAnswers]
		})

		const formTypes = []

		if (isNewForm === 'y') {
			if (mobileReportType) formTypes.push(1)
			if (fixedReportType) formTypes.push(2)
		} else {
			if (continueFormSubmittedType.isFixed) formTypes.push(2)
			if (continueFormSubmittedType.isMobile) formTypes.push(1)
		}
		// version mush be int
		const version = parseInt(reportVersion)

		const res = await form.addRecord(records, isNewForm, formTypes, version)

		if (res?.data?.status === 'Incorrect') {
			const tempInvalidDataSetRecords = res.data.validateResult.map(item => {
				let question = null
				let formType = ''

				if (fixed_general_details.find(q => q.id === item.dataSetItemID)) {
					question = fixed_general_details.find(q => q.id === item.dataSetItemID)
					formType = 'fixed-general'
				} else if (fixed_info_details.find(q => q.id === item.dataSetItemID)) {
					question = fixed_info_details.find(q => q.id === item.dataSetItemID)
					formType = 'fixed-info'
				} else if (fixed_sound_details.find(q => q.id === item.dataSetItemID)) {
					question = fixed_sound_details.find(q => q.id === item.dataSetItemID)
					formType = 'fixed-sound'
				} else if (mobile_general_details.find(q => q.id === item.dataSetItemID)) {
					question = mobile_general_details.find(q => q.id === item.dataSetItemID)
					formType = 'mobile-general'
				} else if (mobile_info_details.find(q => q.id === item.dataSetItemID)) {
					question = mobile_info_details.find(q => q.id === item.dataSetItemID)
					formType = 'mobile-info'
				} else if (mobile_sound_details.find(q => q.id === item.dataSetItemID)) {
					question = mobile_sound_details.find(q => q.id === item.dataSetItemID)
					formType = 'mobile-sound'
				}

				let label = question?.label || ''

				if (question?.subLabel_2) {
					label = `${label} ${question.subLabel_1} (${question.subLabel_2})`
				} else if (question?.subLabel_1) {
					label = `${label} ${question.subLabel_1}`
				}

				return {
					id: question?.id,
					question_number: question?.no,
					label: label,
					errors: item.errors.toString(),
					inputMethod: 'message',
					question: question,
					formType: formType,
				}
			})

			// Only keep invalid answers if they are still invalid
			// If an item was invalid but now is valid, we should remove it from invalidAnswers?
			// Actually, the API returns the full list of current errors.
			// So we can just reset invalidAnswers to match the new list.
			// However, the user might have entered reasons for some items that are still invalid.
			// We should try to preserve existing reasons/solutions for items that persist.

			const tempInvalidAnswers = res.data.validateResult.map(item => {
				const existingAnswer = invalidAnswers.find(ia => ia.id === item.dataSetItemID)
				if (existingAnswer) {
					return {
						...existingAnswer,
						dbID: item.id
					}
				}

				const formVersionStr = reportVersion.toString()
				let isAllZero = false

				if (zeroMapping[formVersionStr] && zeroMapping[formVersionStr].includes(item.dataSetItemID)) {
					const record = records.find(r => r.DataSetItemID === item.dataSetItemID)
					if (record) {
						let m1 = 1, m2 = 1, m3 = 1, avg = 1;
						if (record.DataValueMonth1 !== '') m1 = parseFloat(record.DataValueMonth1) || 0;
						if (record.DataValueMonth2 !== '') m2 = parseFloat(record.DataValueMonth2) || 0;
						if (record.DataValueMonth3 !== '') m3 = parseFloat(record.DataValueMonth3) || 0;
						if (record.DataValueMonthAvg !== '') avg = parseFloat(record.DataValueMonthAvg) || 0;

						const isM1Zero = record.DataValueMonth1 !== '' && Math.abs(m1) < 0.0000001;
						const isM2Zero = record.DataValueMonth2 !== '' && Math.abs(m2) < 0.0000001;
						const isM3Zero = record.DataValueMonth3 !== '' && Math.abs(m3) < 0.0000001;
						const isAvgZero = record.DataValueMonthAvg !== '' && Math.abs(avg) < 0.0000001;

						const hasData = record.DataValueMonth1 !== '' || record.DataValueMonth2 !== '' || record.DataValueMonth3 !== '' || record.DataValueMonthAvg !== '';
						let allProvidedAreZero = true;

						if (record.DataValueMonth1 !== '' && !isM1Zero) allProvidedAreZero = false;
						if (record.DataValueMonth2 !== '' && !isM2Zero) allProvidedAreZero = false;
						if (record.DataValueMonth3 !== '' && !isM3Zero) allProvidedAreZero = false;
						if (record.DataValueMonthAvg !== '' && !isAvgZero) allProvidedAreZero = false;

						if (hasData && allProvidedAreZero) {
							isAllZero = true;
						}
					}
				}

				return {
					id: item.dataSetItemID,
					reason: isAllZero ? 'ไม่มีบริการ' : '',
					solution: isAllZero ? '-' : '',
					periodSolution: isAllZero ? new Date() : null,
					file: null,
					dbID: item.id,
					inputMethod: isAllZero ? 'no_service' : 'message',
				}
			})

			setInvalidDataSetRecords([...tempInvalidDataSetRecords])
			setInvalidAnswers([...tempInvalidAnswers])
			Swal.fire({
				icon: 'warning',
				title: 'ผลการตรวจสอบ',
				text: 'ยังพบข้อมูลที่ไม่ถูกต้อง กรุณาตรวจสอบและแก้ไขข้อมูลในรายการด้านล่าง',
				confirmButtonColor: '#1976d2',
			})
		} else {
			// Validation passed!
			setInvalidDataSetRecords([])
			setInvalidAnswers([])
			Swal.fire({
				icon: 'success',
				title: 'ตรวจสอบข้อมูลสำเร็จ',
				text: 'ข้อมูลทั้งหมดถูกต้องแล้ว',
				confirmButtonColor: '#1976d2',
			})
		}
		setLoading(false)
	}

	/** Step 2 Upload File */
	const uploadExcel = async () => {
		setLoading(true)
		const formTypes = []
		if (mobileReportType) formTypes.push(1)
		if (fixedReportType) formTypes.push(2)

		const resExcelFile = await form.excelUploading(
			excelFile,
			isNewForm,
			reportVersion,
			formTypes
		)
		setLoading(false)

		// Wrong format
		if (resExcelFile?.response?.status === 422) {
			setUploadExcelStatus(false)
		} else {
			// Wrong answer. But correct format
			if (resExcelFile?.response?.status === 400) {
				if (!Array.isArray(resExcelFile.response.data)) {
					alert(resExcelFile.response.data.message)
					setLoading(false)
					return
				}
				const tempInvalidDataSetRecords = resExcelFile.response.data.map(
					item => {
						let question = null
						let formType = ''

						if (fixed_general_details.find(q => q.id === item.dataSetItemID)) {
							question = fixed_general_details.find(q => q.id === item.dataSetItemID)
							formType = 'fixed-general'
						} else if (fixed_info_details.find(q => q.id === item.dataSetItemID)) {
							question = fixed_info_details.find(q => q.id === item.dataSetItemID)
							formType = 'fixed-info'
						} else if (fixed_sound_details.find(q => q.id === item.dataSetItemID)) {
							question = fixed_sound_details.find(q => q.id === item.dataSetItemID)
							formType = 'fixed-sound'
						} else if (mobile_general_details.find(q => q.id === item.dataSetItemID)) {
							question = mobile_general_details.find(q => q.id === item.dataSetItemID)
							formType = 'mobile-general'
						} else if (mobile_info_details.find(q => q.id === item.dataSetItemID)) {
							question = mobile_info_details.find(q => q.id === item.dataSetItemID)
							formType = 'mobile-info'
						} else if (mobile_sound_details.find(q => q.id === item.dataSetItemID)) {
							question = mobile_sound_details.find(q => q.id === item.dataSetItemID)
							formType = 'mobile-sound'
						}

						let label = question?.label || ''

						if (question?.subLabel_2) {
							label = `${label} ${question.subLabel_1} (${question.subLabel_2})`
						} else if (question?.subLabel_1) {
							label = `${label} ${question.subLabel_1}`
						}

						return {
							id: question?.id,
							question_number: question?.no,
							label: label,
							errors: item.errors.toString(),
							inputMethod: 'message',
							question: question,
							formType: formType,
						}
					}
				)

				const tempInvalidAnswers = resExcelFile.response.data.map(item => {
					return {
						id: item.dataSetItemID,
						reason: item.reason || '',
						solution: item.solution || '',
						periodSolution: item.reason === 'ไม่มีบริการ' ? new Date() : null,
						file: null,
						dbID: item.id,
						inputMethod: item.reason === 'ไม่มีบริการ' ? 'no_service' : 'message',
					}
				})

				setInvalidDataSetRecords([...tempInvalidDataSetRecords])
				setInvalidAnswers([...tempInvalidAnswers])
			}

			setActiveStep(prev => prev + 1)

			setUploadExcelStatus(true)
		}
	}

	/** ---------------------------------------------- */

	/** Step 3 */

	const onOpenSubmitStandardReportSureModal = () => {
		setOpenSubmitStandardReportSureModal(!openSubmitStandardReportSureModal)
	}

	/** ---------------------------------------------- */

	const onInputAdditionalFile = (e, type) => {
		const { files } = e.target

		if (files.length !== 0) {
			setMobileFiles(prevState => ({
				...prevState,
				[type]: [...(prevState[type] || []), files[0]],
			}))
		}
	}

	const onDeleteAdditionalFile = (index, type) => {
		setMobileFiles(prevState => {
			let filesArr = prevState[type]

			const tempList = filesArr.filter((_, idx) => idx !== index)

			return {
				...prevState,
				[type]: tempList,
			}
		})
	}

	const uploadAdditionalFile = async () => {
		const resCurrentHead = await datasetRecord.getCurrentHead()

		if (resCurrentHead && resCurrentHead?.status === 200) {
			const res = await datasetRecord.uploadAdditionalFile(
				resCurrentHead.data.id,
				mobileFiles
			)
			if (res) {
				if (res.status === 200) {
					setActiveStep(prevActiveStep => prevActiveStep + 1)
				} else if (res.status === 400) {
				}
			}
		}
	}

	/** ---------------------------------------------- */

	/** Step 4 */

	const onInputValidationReason = (e, id, isPeriodSolution) => {
		if (isPeriodSolution) {
			setInvalidAnswers(prevAnswers => {
				let newAnswers = prevAnswers.find(ans => ans.id === id)
				newAnswers['periodSolution'] = moment(e).format('YYYY-MM-DD')
				const filtered = prevAnswers.filter(ans => ans.id !== id)
				filtered.push(newAnswers)

				return filtered
			})
		} else {
			const { name, value, files } = e.target

			if (name === 'file') {
				setInvalidAnswers(prevAnswers => {
					let newAnswers = prevAnswers.find(ans => ans.id === id)
					newAnswers['file'] = files[0]

					const filtered = prevAnswers.filter(ans => ans.id !== id)
					filtered.push(newAnswers)

					return filtered
				})
			} else if (!isPeriodSolution) {
				setInvalidAnswers(prevAnswers => {
					let newAnswers = prevAnswers.find(ans => ans.id === id)
					newAnswers[name] = value

					const filtered = prevAnswers.filter(ans => ans.id !== id)
					filtered.push(newAnswers)

					return filtered
				})
			}
		}
	}

	const onChangeInvalidaInputMethod = val => setInvalidInputMethod(val)

	const onAskInvalidInputMethod = val => {
		if (val === 'no_service') {
			setInvalidAnswers(prevState => {
				const temp = [...prevState]
				const index = temp.findIndex(
					item => item.id === currentSelectedItem.id
				)
				if (index > -1) {
					temp[index] = {
						...temp[index],
						inputMethod: val,
						reason: 'ไม่มีบริการ',
						solution: '-',
						periodSolution: moment().format('YYYY-MM-DD'),
						file: null,
					}
					setCurrentSelectedItem(temp[index])
				}
				return temp
			})
			setOpenAskingValidationModal(false)
		} else {
			setInvalidAnswers(prevState => {
				const temp = [...prevState]
				const index = temp.findIndex(
					item => item.id === currentSelectedItem.id
				)
				if (index > -1) {
					temp[index] = {
						...temp[index],
						inputMethod: val,
					}
					setCurrentSelectedItem(temp[index])
				}
				return temp
			})
		}
	}

	const onOpenAskingValidationModal = id => {
		const question = invalidAnswers.find(item => item.id === id)

		setCurrentSelectedItem(question)
		setCurrentValidationQuestionNumber(id)
		setOpenAskingValidationModal(true)
		setOpenFillingModal(true)
	}

	const onCloseAskingValidationModal = () => {
		setOpenAskingValidationModal(false)
		if (currentSelectedItem?.inputMethod === 'no_service' ||
			// Also check invalidAnswers in case currentSelectedItem is stale, though we updated it above
			invalidAnswers.find(x => x.id === currentSelectedItem?.id)?.inputMethod === 'no_service'
		) {
			setOpenFillingModal(false)
		}
	}

	const onCloseFillingModal = () => setOpenFillingModal(false)

	const onSubmitToApprove = async () => {
		const resCurrentHead = await datasetRecord.getCurrentHead()

		if (resCurrentHead) {
			const res = await datasetRecord.sendToApprove(
				resCurrentHead.data.id,
				invalidAnswers
			)
			if (res) {
				onOpenSubmitStandardReportSureModal()

				if (res.status === 200) {
					// onOpenStandardReportSuccessModal()
					Swal.fire({
						title: 'ส่งข้อมูลสำเร็จ',
						text: 'ท่านต้องการกรอกแบบประเมินความพึงพอใจหรือไม่?',
						icon: 'success',
						confirmButtonText: 'ต้องการ',
						showCancelButton: true,
						cancelButtonText: 'ไม่ต้องการ',
					}).then(result => {
						if (result.isConfirmed) {
							window.open(
								'https://docs.google.com/forms/d/e/1FAIpQLSd3Kh9APHngJ16OWX9QbijN36-h_4YV9DxM59X8E8zetJf7Iw/viewform?usp=sf_link',
								'_blank'
							)
						}
					})
				}
				else {
					setSendingFailedMessage(res.data?.message ?? '')
					onOpenStandardReportFailedModal()
				}
				// fire swal that will show link to do survey from google from



			}
		}
	}

	/** ---------------------------------------------- */

	/**  Main Rendering */

	const nextButtonGenerator = () => {
		// On last step
		if (loading) {
			return 'กรุณารอสักครู่'
		} else if (
			activeStep === (hasMobile ? stepsMobile.length - 1 : steps.length - 1)
		)
			return 'ส่งไปยังผู้อนุมัติ'
		// General cases
		else return 'ขั้นตอนถัดไป'
	}

	const buttonNextDisabled = useMemo(() => {
		if (activeStep === 2 && hasMobile) {
			let hasFile = false
			// eslint-disable-next-line
			for (const [key, value] of Object.entries(mobileFiles)) {
				if (value.length > 0) {
					hasFile = true
				}
			}
			// const keys = Object.keys(mobileFiles)
			// const isDisable = keys.every(item => mobileFiles[item].length > 0)

			return hasFile
		} else if (
			activeStep === (hasMobile ? stepsMobile.length - 1 : steps.length - 1)
		) {
			const isPass = invalidAnswers.some(item => {
				return (
					item.reason === '' &&
					item.solution === '' &&
					item.periodSolution === '' &&
					item.file === null
				)
			})

			return isPass && invalidAnswers.length !== 0
		}
		// When Input form and Method is Upload
		else if (activeStep === 1 && reportMethod === 'upload')
			return excelFileShow === ''
		// When Input form and Method is WebForm
		else if (activeStep === 1 && reportMethod === 'web-form') return false
		else if (activeStep === 0 && isNewForm === 'n') return false
		else return !fixedReportType && !mobileReportType
	}, [
		activeStep,
		excelFileShow,
		fixedReportType,
		hasMobile,
		invalidAnswers,
		isNewForm,
		mobileReportType,
		mobileFiles,
		reportMethod,
		steps.length,
		stepsMobile.length,
	])

	const uploadAdditionalFileButtonDisabled = () => {
		if (activeStep === 2 && hasMobile) {
			const keys = Object.keys(mobileFiles)
			const isDisable = keys.every(item => mobileFiles[item].length === 0)

			return isDisable
		}
	}

	const onGenerateAnswer = useCallback(() => {
		/**
		 * 	Answer Object Example
		 *
		 *   {
		 *  	DataSetItemID: Integer,
		 *      DataValueMonth1: Float | Integer,
		 *      DataValueMonth2: Float | Integer,
		 *      DataValueMonth3: Float | Integer,
		 *      DataValueMonthAvg: Float | Integer
		 *   }
		 *
		 */
		loadReportData();

		needToFillFormType.forEach(type => {

			if (
				!fixed_general_details || !fixed_info_details || !fixed_sound_details ||
				!mobile_general_details || !mobile_info_details || !mobile_sound_details
			) {
				return; // Exit the function if data isn't ready
			}
			if (type === 'fixed-general') {
				const temp = fixed_general_details.map(item => {
					return {
						DataSetItemID: item.id,
						DataValueMonth1: '',
						DataValueMonth2: '',
						DataValueMonth3: '',
						DataValueMonthAvg: '',
					}
				})
				setFixedGeneralAnswers(temp)
			} else if (type === 'fixed-info') {
				const temp = fixed_info_details.map(item => {
					return {
						DataSetItemID: item.id,
						DataValueMonth1: '',
						DataValueMonth2: '',
						DataValueMonth3: '',
						DataValueMonthAvg: '',
					}
				})
				setFixedInfoAnswers(temp)
			} else if (type === 'fixed-sound') {
				const temp = fixed_sound_details.map(item => {
					return {
						DataSetItemID: item.id,
						DataValueMonth1: '',
						DataValueMonth2: '',
						DataValueMonth3: '',
						DataValueMonthAvg: '',
					}
				})
				setFixedSoundAnswers(temp)
			} else if (type === 'mobile-general') {
				const temp = mobile_general_details.map(item => {
					return {
						DataSetItemID: item.id,
						DataValueMonth1: '',
						DataValueMonth2: '',
						DataValueMonth3: '',
						DataValueMonthAvg: '',
					}
				})
				setMobileGeneralAnswers(temp)
			} else if (type === 'mobile-info') {
				const temp = mobile_info_details.map(item => {
					return {
						DataSetItemID: item.id,
						DataValueMonth1: '',
						DataValueMonth2: '',
						DataValueMonth3: '',
						DataValueMonthAvg: '',
					}
				})
				setMobileInfoAnswers(temp)
			} else if (type === 'mobile-sound') {
				const temp = mobile_sound_details.map(item => {
					return {
						DataSetItemID: item.id,
						DataValueMonth1: '',
						DataValueMonth2: '',
						DataValueMonth3: '',
						DataValueMonthAvg: '',
						DataValueExtra: '',
					}
				})
				setMobileSoundAnswers(temp)
			}
		})

		setFilledFormAmount(needToFillFormType.length)
	}, [needToFillFormType])

	const onGetCurrentHead = async () => {
		let twoG = false
		let nvmo = false
		let payphone = false
		const res = await datasetRecord.getCurrentHead()

		if (res && res?.status === 200) {
			const data = res.data

			if (data.dataSetReport.operator) {
				// 2G Checking
				if (data.dataSetReport.operator?.is2G === 'y') twoG = true

				// NVMO Checking
				if (data.dataSetReport.operator?.ownerNVOM === 'y') nvmo = true

				// Payphone Checking
				if (data.dataSetReport.operator?.isPayphone === 'y') payphone = true

				setFlags({
					'2G': twoG,
					NVMO: nvmo,
					payphone: payphone,
				})
			}
			if (data.formVersion !== null) {
				setReportVersion(data.formVersion)
			} else {
				setReportVersion('2')
			}
			// if (data.sendMethod > 1) setHasEverSubmitedForm(true)
			if (data.sendMethod !== null) setHasEverSubmitedForm(true)

			setContinueFormSubmittedID(data.id)

			setContinueFormSubmittedType({
				isFixed: data.isFixed === 'y',
				isMobile: data.isMobile === 'y',
				version: data.formVersion !== null ? data.formVersion : '1',
			})

			setCurrentHeadData(data)

			setHasMounted(true)
		}
	}

	useEffect(
		() => onChangeNeedToFillFormType(),
		// eslint-disable-next-line
		[fixedReportType, mobileReportType, isNewForm, isUseReport1_1_2]
	)

	// On Mounting the page
	useEffect(() => {
		onGenerateAnswer()
	}, [onGenerateAnswer])

	useEffect(() => {
		onGetCurrentHead()
		// Swal.fire({
		// 	title: 'ส่งข้อมูลสำเร็จ',
		// 	text: 'ท่านต้องการกรอกแบบสำรวจหรือไม่?',
		// 	icon: 'success',
		// 	confirmButtonText: 'ต้องการ',
		// 	showCancelButton: true,
		// 	cancelButtonText: 'ไม่ต้องการ',
		// }).then(result => {
		// 	if (result.isConfirmed) {
		// 		window.open(
		// 			'https://docs.google.com/forms/d/e/1FAIpQLSd3Kh9APHngJ16OWX9QbijN36-h_4YV9DxM59X8E8zetJf7Iw/viewform?usp=sf_link',
		// 			'_blank'
		// 		)
		// 	}
		// })
	}, [])

	useEffect(() => {
		loadReportData();
		const obj = {}
		if (!mobile_additional_files) return
		mobile_additional_files.forEach(item => {
			obj[item.key] = []
		})

		setMobileFiles(obj)
	}, [])

	useEffect(() => {
		loadReportData();
	}, [reportVersion]);

	return (
		<>
			<Grid className="min-h-screen flex flex-col pb-10 px-2 lg:px-10">
				<Grid className={`${classes.root} h-full`}>
					<Stepper
						style={{ backgroundColor: 'transparent' }}
						alternativeLabel
						activeStep={activeStep}
						connector={<Connector />}>
						{hasMobile && activeStep > 0
							? stepsMobile.map(label => (
								<Step alternativeLabel key={label}>
									<StepLabel StepIconComponent={(props) => <StepperIcon {...props} hasMobile={hasMobile} />}>
										{label}
									</StepLabel>
								</Step>
							))
							: steps.map(label => (
								<Step alternativeLabel key={label}>
									<StepLabel StepIconComponent={(props) => <StepperIcon {...props} hasMobile={hasMobile} />}>
										{label}
									</StepLabel>
								</Step>
							))}
					</Stepper>
					<Grid>
						{activeStep === (hasMobile ? stepsMobile.length : steps.length) ? (
							<Grid>
								<Typography className={classes.instructions}>
									All steps completed - you&apos;re finished
								</Typography>
							</Grid>
						) : (
							<Grid
								container
								direction="row"
								justifyContent="center"
								className="pb-14 ">
								<Grid container item>
									<Grid
										className={`${classes.instructions} w-full pb-4`}
										component="div">
										<StepContent
											quarter={quarter}
											// Main State
											activeStep={activeStep}
											hasMobile={hasMobile}
											// Standard Report Form Handler State
											flags={flags}
											needToFillFormType={needToFillFormType}
											filledFormAmount={filledFormAmount}
											currentFilledFormIndex={currentFilledFormIndex}
											onFillForm={onFillForm}
											// Standard Report Answers
											fixedGeneralAnswers={fixedGeneralAnswers}
											fixedInfoAnswers={fixedInfoAnswers}
											fixedSoundAnswers={fixedSoundAnswers}
											mobileGeneralAnswers={mobileGeneralAnswers}
											mobileInfoAnswers={mobileInfoAnswers}
											mobileSoundAnswers={mobileSoundAnswers}
											// Report Definitions
											fixedGeneralDetails={fixed_general_details}
											fixedInfoDetails={fixed_info_details}
											fixedSoundDetails={fixed_sound_details}
											mobileGeneralDetails={mobile_general_details}
											mobileInfoDetails={mobile_info_details}
											mobileSoundDetails={mobile_sound_details}
											// Debug Trigger
											debug={null}
											// Step1
											userOperatorProfile={userOperatorProfile}
											reportMethod={reportMethod}
											reportVersion={reportVersion}
											onChangeRadio={onChangeRadio}
											fixedReportTypeRadioValue={fixedReportType}
											mobileReportTypeRadioValue={mobileReportType}
											onChangeReportType={onChangeReportType}
											setVersion={setVersion}
											hasEverSubmitedForm={hasEverSubmitedForm}
											isNewForm={isNewForm}
											onChangeIsContinueRadio={onChangeIsContinueRadio}
											continueFormSubmittedType={continueFormSubmittedType}
											currentHeadData={currentHeadData}
											// Step 2 Upload File
											excelFile={excelFile}
											setExcelFile={setExcelFile}
											excelFileShow={excelFileShow}
											setExcelFileShow={setExcelFileShow}
											previewAnswers={previewAnswers}
											setPreviewAnswers={setPreviewAnswers}
											// Step 3 Additional Files
											mobileFiles={mobileFiles}
											mobileAdditionalFiles={mobile_additional_files}
											onInputAdditionalFile={onInputAdditionalFile}
											onDeleteAdditionalFile={onDeleteAdditionalFile}
											// Step 4 Validation
											invalidDataSetRecords={invalidDataSetRecords}
											invalidAnswers={invalidAnswers}
											onInputValidationReason={onInputValidationReason}
											invalidInputMethod={invalidInputMethod}
											onChangeInvalidaInputMethod={onChangeInvalidaInputMethod}
											openAskingValidationModal={openAskingValidationModal}
											onOpenAskingValidationModal={onOpenAskingValidationModal}
											onCloseAskingValidationModal={
												onCloseAskingValidationModal
											}
											onCloseFillingModal={onCloseFillingModal}
											onAskInvalidInputMethod={onAskInvalidInputMethod}
											currentValiationQuestionNumber={
												currentValiationQuestionNumber
											}
											openFillingModal={openFillingModal}
											currentSelectedItem={currentSelectedItem}
											onReValidate={handleReValidate}
											userOverride={{
												isUseReport1_1_2: isUseReport1_1_2
											}}
										/>
									</Grid>
								</Grid>
								<Grid
									container
									item
									direction="row"
									justifyContent="space-between"
									alignItems="baseline"
									className="w-full">
									<Grid item>
										<Button
											disabled={activeStep === 0}
											onClick={handleBack}
											variant="contained"
											className="w-36">
											ย้อนกลับ
										</Button>
									</Grid>
									<Grid item className="flex flex-row gap-x-5">
										{hasMobile && activeStep === 2 && (
											<Button
												disabled={uploadAdditionalFileButtonDisabled()}
												onClick={uploadAdditionalFile}
												variant="contained"
												color="secondary"
												className={`w-36`}>
												บันทึกเอกสารแนบ
											</Button>
										)}
										<Button
											disabled={buttonNextDisabled || loading}
											variant="contained"
											color="secondary"
											onClick={handleNext}
											className={`w-36`}>
											{nextButtonGenerator()}
										</Button>
									</Grid>
								</Grid>
							</Grid>
						)}
					</Grid>
				</Grid>
			</Grid>
			<SendingStandardReportModalSuccess
				open={openStandardReportSuccessModal}
				handleButton={onAgreeStandardReportSuccessModalCTA}
			/>
			<SendingStandardReportModalFailed
				open={openStandardReportFailedModal}
				message={sendingFailedMessage}
				handleButton={onOpenStandardReportFailedModal}
			/>
			{/* Upload Excel Failed Status Modal */}
			<SendingStandardReportModalFailed
				open={uploadExcelStatus === false}
				message={'format ของไฟล์ excel ไม่ถูกต้อง โปรดลองอีกครั้ง'}
				handleButton={() => {
					setUploadExcelStatus(null)
				}}
			/>
			<SureModal
				title="ส่งรายงานมาตรฐานคุณภาพ"
				content="คุณแน่ใจที่จะส่งรายงานมาตรฐานคุณภาพไปยังผู้อนุมัติหรือไม่"
				header_icon={
					<SendOutlined style={{ fontSize: 20 }} className="mr-1 text-white" />
				}
				open={openSubmitStandardReportSureModal}
				onClose={onOpenSubmitStandardReportSureModal}
				handleCancel={onOpenSubmitStandardReportSureModal}
				handleButton={onSubmitToApprove}
			/>
			<EmptyFileModal
				open={openEmptyFileModal}
				handleButton={onOpenEmptyFileModal}
			/>
		</>
	);
}

export default StandardReport
